import type { ReactNode } from 'react';
import Breadcrumbs from '@/components/Breadcrumbs';
import type { Crumb } from '@/components/SEO';

interface PageHeaderProps {
  label?: string;
  title: string;
  lead?: string;
  crumbs?: Crumb[];
  children?: ReactNode;
}

// Hub / page header on cream: breadcrumbs → label → H1 → lead, bottom rule.
const PageHeader = ({ label, title, lead, crumbs, children }: PageHeaderProps) => (
  <header className="border-b border-rule">
    <div className="container py-12 md:py-16">
      {crumbs && <Breadcrumbs items={crumbs} />}
      {label && <p className={`label ${crumbs ? 'mt-8' : ''}`}>{label}</p>}
      <h1 className="mt-4 max-w-4xl text-[2.5rem] font-bold leading-[1.08] md:text-headline">{title}</h1>
      {lead && <p className="mt-6 max-w-3xl text-lead">{lead}</p>}
      {children}
    </div>
  </header>
);

export default PageHeader;
